document.addEventListener("DOMContentLoaded", () => {
  const animations = document.querySelectorAll(".company-history-animation");

  if (animations && animations.length > 0) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("scroll-animation");
          } else {
            entry.target.classList.remove("scroll-animation");
          }
        });
      },
      { threshold: 0, rootMargin: "0px 0px -50px 0px" }
    );

    for (let i = 0; i < animations.length; i++) {
      const elements = animations[i];

      observer.observe(elements);
    }
  }
});
